import React from 'react';
import NumberFormat from 'react-number-format';

interface Props {
  value: number;
  className?: string;
  dollarPrefix?: boolean;
}

const renderValue = value => value;

function NumberFormats({ value, className = '', dollarPrefix }: Props) {
  const prefix = dollarPrefix ? 'USD ' : undefined;
  const render = dollarPrefix ? renderValue : undefined;
  return (
    <NumberFormat
      value={value}
      displayType="text"
      prefix={prefix}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      renderText={render}
      className={className}
    />
  );
}

export default NumberFormats;
